// extracted by mini-css-extract-plugin
export default {"offcanvas":"offcanvas_offcanvas__4XKra"};